<nav *ngIf="(menuSignal())?.length > 0" role="navigation" aria-label="subnavigation menu">
  <ul class="nav subnav-tabs">
    <li *ngFor="let menuItem of menuSignal() "  class="nav-item mb-0 nav-link subnav-link">
      <!-- Does not use aria labels, screen readers use the aria-current attribute and the label text -->
      <a
        id={{menuItem.id}}
        [routerLink]="menuItem.route"
        *ngIf="!menuItem.disabled else disabledLink"
        routerLinkActive="active"
        #rla="routerLinkActive"
        [attr.aria-current]="rla.isActive"
        [routerLinkActiveOptions]="{exact: true}"
        queryParamsHandling="merge">
        {{menuItem.label}}
      </a>

      <ng-template #disabledLink>
        <p class="disabled-subnav-item" [ngbTooltip]="menuItem.tooltip">
          {{menuItem.label}}
        </p>
      </ng-template>
  </li>
  </ul>
</nav>
